import React, { useState } from 'react';
import parse from 'html-react-parser';
import TokenIcon from './TokenIcon.mjs';

export default function RedeemablePerk({ perkProps, onSelect, onQtyChange, perk, curTokens, curScore, curPerkIndex, updateIndex, access=true }) {
	let { name, amount, description, icon } = perk;

	const [perkIndex, setPerkIndex] = useState(() => {
		const thisIndex = curPerkIndex.current;
		updateIndex();
		return thisIndex;
	});
	const { id, selected, qty, costTokens, costPoints } = perkProps[perkIndex];

  if (id === '11006') {
    // For this particular perk, apply the h3 class to the $200
    let valueToHighlight = '$200';
    let parts = name.split(valueToHighlight);
    name = (
      <>
        {parts[0]}
        {parts.length > 1 && (
          <span className="h3">{valueToHighlight}</span>
        )}
        {parts[1]}
      </>
    );
  }

	const qtyDisabled = curTokens < costTokens || curScore < costPoints;
	const disabled = !access || !selected && qtyDisabled;

  const handleOnCheck = (id, wasSelected) => {
    onSelect(id);

    if (wasSelected && qty > 0) {
      onQtyChange(id, 'clear');
    }
  };

	return (
		<div className='redeemable-perk bg-light d-flex flex-wrap gap-2 gap-md-3 align-items-center rounded-1' data-disabled={disabled}>
			<button className='perk-select p-0 border-0 d-flex' role='button' onClick={() => handleOnCheck(id, selected)} disabled={disabled}>
				<span className='material-icons flex-shrink-0 fs-3'>{selected ? 'check_box' : 'check_box_outline_blank'}</span>
			</button>
			<div className='perk-icon flex-shrink-0 d-none d-md-block'>
				<TokenIcon name={icon} width='56' height='56' />
			</div>
			<div className='perk-details flex-grow-1'>
				<span className='h4 mb-1'>
					<span className='h3'>{amount}</span> {name}
				</span>
				<span className='label-3 d-block'>{description}</span>
			</div>
			{selected && (
				<div className='perk-quantity ms-md-auto d-flex justify-content-md-end align-items-center gap-3'>
					<button className='qty-btn qty-subtract rounded-circle d-flex' role='button' disabled={qty <= 1} onClick={() => onQtyChange(id, 'subtract')}>
						<span className='material-icons fs-3'>remove</span>
					</button>
					<span className='h2 mb-0'>{qty}</span>
					<button className='qty-btn qty-subtract rounded-circle d-flex' role='button' disabled={qtyDisabled} onClick={() => onQtyChange(id, 'add')}>
						<span className='material-icons fs-3'>add</span>
					</button>
				</div>
			)}
		</div>
	);
}
